import script from "./DataTableColumnSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableColumnSort.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableColumnSort.vue?vue&type=style&index=0&id=405655e5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405655e5"]])

export default __exports__